export enum AcceptedUserEnum {
  Initial = 1,
  Tester,
}
